import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { Accordion } from '@carbonify/ui';
import RichContent from 'components/RichContent/RichContent';

import { StructuredText } from '.';

export interface AccordionEntryRecord extends CdaStructuredTextRecord {
  title: string;
  content: StructuredText;
  open?: boolean;
  category?: string;
}

export default function AccordionEntry({ title, content, open }: AccordionEntryRecord) {
  return (
    <Accordion
      header={title}
      open={open}
    >
      <RichContent>{content}</RichContent>
    </Accordion>
  );
}
